import { navLinks, WEB_LINK } from "../../constants";
import { useTranslation } from "react-i18next";
import { SlideLeft, SlideOpacity, SlideRight, SlideUp } from "../../utils";
import { m } from "framer-motion";
import { MapPin } from "lucide-react";
import { CustomLink } from "../../main-parts/link";

const Footer = () => {
  const { t } = useTranslation();
  // const navLinks = navLinks.slice(0, 5);

  return (
    <footer className="md:mt-[80px] mt-[50px] pt-[50px] md:bg-footer bg-footer-media bg-cover bg-no-repeat bg-center sm:px-3 relative before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-black-color/70 before:z-10">
      <m.div className="container relative z-20">
        <div className="flex justify-between flex-row flex-wrap gap-y-5">
          <m.div className="lg:w-[28%] sm:w-1/2 w-full flex flex-col">
            <m.div
              viewport={{ once: true }}
              variants={SlideRight(0.2)}
              initial="initial"
              whileInView="animate"
              className="flex text-3xl pb-3 font-bold text-white-color mb-6"
            >
              <span>ESM</span>
              <span className="text-primary">.</span>
            </m.div>
            <div className="pt-6">
              <CustomLink
                className="text-white-color flex flex-col duration-200 active:scale-95 hover:opacity-80"
                to={WEB_LINK.map_url}
              >
                <m.span
                  viewport={{ once: true }}
                  variants={SlideUp(0.4)}
                  initial="initial"
                  whileInView="animate"
                  className="flex items-center gap-x-2"
                >
                  <span>
                    <MapPin size={18} />
                  </span>
                  <span>{t(WEB_LINK.map_title)} </span>
                </m.span>
                <m.span
                  viewport={{ once: true }}
                  variants={SlideUp(0.6)}
                  initial="initial"
                  whileInView="animate"
                >
                  {t("kangli_street")}.
                </m.span>
              </CustomLink>
            </div>
            <m.a
              viewport={{ once: true }}
              variants={SlideUp(0.8)}
              initial="initial"
              whileInView="animate"
              href={`tel:${WEB_LINK.phone}`}
              className="mt-3 flex items-center text-white-color gap-x-1 duration-200 active:scale-95 hover:opacity-80"
            >
              <span className=" font-extrabold">{t("phone")}:</span>
              <span>{WEB_LINK.phone}</span>
            </m.a>
            <m.a
              viewport={{ once: true }}
              variants={SlideUp(1)}
              initial="initial"
              whileInView="animate"
              href={`mailto:${WEB_LINK.email}`}
              className="mt-3 flex items-center text-white-color gap-x-1 duration-200 active:scale-95 hover:opacity-80"
            >
              <span className=" font-extrabold">{t("email")}:</span>
              <span>{WEB_LINK.email}</span>
            </m.a>
            <div className="mt-8">
              <m.button
                type="button"
                viewport={{ once: true }}
                variants={SlideRight(1.2)}
                initial="initial"
                whileInView="animate"
                className="py-3 px-6 rounded-full text-white-color bg-primary duration-300 hover:opacity-80 active:scale-95"
              >
                <CustomLink
                  to={WEB_LINK.map_url}
                  className="flex items-center gap-x-2"
                >
                  <span>
                    <MapPin size={18} />
                  </span>
                  {t("open_in_map")}
                </CustomLink>
              </m.button>
            </div>
          </m.div>
          <div className="lg:w-[18%] sm:w-1/2 w-full">
            <m.h2
              viewport={{ once: true }}
              variants={SlideLeft(0.2)}
              initial="initial"
              whileInView="animate"
              className="text-white-color text-xl font-bold w-max active:scale-95 duration-200 relative    before:absolute before:bottom-0 before:left-0 before:h-[3px] before:bg-primary before:w-[110%] pb-[2px]"
            >
              {t("useful_links")}
            </m.h2>

            <div className="pt-7 flex flex-col gap-y-5">
              {navLinks.map((el, i) => (
                <m.div
                  className="overflow-hidden"
                  key={i}
                  viewport={{ once: true }}
                  variants={SlideUp(i * 0.17)}
                  initial="initial"
                  whileInView="animate"
                >
                  <CustomLink
                    className="text-white-color text-base w-max active:scale-95 duration-200 relative before:absolute before:bottom-0 before:-left-full before:h-[3px] before:bg-primary before:w-full pb-[2px] before:duration-300 hover:before:left-0"
                    href={`${el.path}`}
                  >
                    {t(el.title)}
                  </CustomLink>
                </m.div>
              ))}
            </div>
          </div>
          <div className="xl:w-[18%] lg:w-[22%] lg:pl-5 xl:pl-0 sm:w-1/2 w-full">
            <m.h2
              viewport={{ once: true }}
              variants={SlideLeft(0.2)}
              initial="initial"
              whileInView="animate"
              className="text-white-color text-xl font-bold w-max active:scale-95 duration-200 relative before:absolute before:bottom-0 before:left-0 before:h-[3px] before:bg-primary before:w-[110%] pb-[2px]"
            >
              {t("activity_types")}
            </m.h2>

            <div className="pt-7 flex flex-col gap-y-5">
              {navLinks.map((el, i) => (
                <m.div
                  className="overflow-hidden"
                  key={i}
                  viewport={{ once: true }}
                  variants={SlideUp(i * 0.17)}
                  initial="initial"
                  whileInView="animate"
                >
                  <CustomLink
                    className="text-white-color text-base w-max active:scale-95 duration-200 relative before:absolute before:bottom-0 before:-left-full before:h-[3px] before:bg-primary before:w-full pb-[2px] before:duration-300 hover:before:left-0"
                    href={`${el.path}`}
                  >
                    {t(el.title)}
                  </CustomLink>
                </m.div>
              ))}
            </div>
          </div>
          <div className="xl:w-[18%] lg:w-[16%] sm:w-1/2 w-full lg:pl-5">
            <m.h2
              viewport={{ once: true }}
              variants={SlideLeft(0.2)}
              initial="initial"
              whileInView="animate"
              className="text-white-color text-xl font-bold w-max active:scale-95 duration-200 relative before:absolute before:bottom-0 before:left-0 before:h-[3px] before:bg-primary before:w-[110%] pb-[2px]"
            >
              {t("projects")}
            </m.h2>

            <div className="pt-7 flex flex-col gap-y-5">
              {navLinks.map((el, i) => (
                <m.div
                  className="overflow-hidden"
                  key={i}
                  viewport={{ once: true }}
                  variants={SlideUp(i * 0.17)}
                  initial="initial"
                  whileInView="animate"
                >
                  <CustomLink
                    className="text-white-color text-base w-max active:scale-95 duration-200 relative before:absolute before:bottom-0 before:-left-full before:h-[3px] before:bg-primary before:w-full pb-[2px] before:duration-300 hover:before:left-0"
                    href={`${el.path}`}
                  >
                    {t(el.title)}
                  </CustomLink>
                </m.div>
              ))}
            </div>
          </div>
          <div className="xl:w-[18%] lg:w-[16%] sm:w-1/2 w-full ">
            <m.h2
              viewport={{ once: true }}
              variants={SlideLeft(0.2)}
              initial="initial"
              whileInView="animate"
              className="text-white-color text-xl font-bold w-max active:scale-95 duration-200 relative before:absolute before:bottom-0 before:left-0 before:h-[3px] before:bg-primary before:w-[110%] pb-[2px]"
            >
              {t("news")}
            </m.h2>

            <div className="pt-7 flex flex-col gap-y-5">
              {navLinks.map((el, i) => (
                <m.div
                  className="overflow-hidden"
                  key={i}
                  viewport={{ once: true }}
                  variants={SlideUp(i * 0.17)}
                  initial="initial"
                  whileInView="animate"
                >
                  <CustomLink
                    className="text-white-color text-base w-max active:scale-95 duration-200 relative before:absolute before:bottom-0 before:-left-full before:h-[3px] before:bg-primary before:w-full pb-[2px] before:duration-300 hover:before:left-0"
                    href={`${el.path}`}
                  >
                    {t(el.title)}
                  </CustomLink>
                </m.div>
              ))}
            </div>
          </div>
        </div>
        <m.div
          viewport={{ once: true }}
          variants={SlideOpacity(1.8)}
          initial="initial"
          whileInView="animate"
          className="mt-10 py-5 flex gap-x-1 sm:flex-row flex-col items-center justify-center border-t-2 border-white-color/20 text-white text-base"
        >
          <p>© {new Date().getFullYear()}. {t("copyright")}</p>
          <CustomLink to={"/"}>
            {t("developed_by")} <span className="dev">Sherzod.dev</span>
          </CustomLink>
        </m.div>
      </m.div>
    </footer>
  );
};

export default Footer;
